import { render, staticRenderFns } from "./new_order.vue?vue&type=template&id=690c9bb6&scoped=true"
import script from "./new_order.vue?vue&type=script&lang=js"
export * from "./new_order.vue?vue&type=script&lang=js"
import style0 from "./new_order.vue?vue&type=style&index=0&id=690c9bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690c9bb6",
  null
  
)

export default component.exports